import React from 'react';
import { SectionTitle } from 'styles/typographies';
import Carousel from 'components/Carousel';
import SlideItem from 'components/ProductSlideItem';
import { NormalizedProduct } from '../../../../@types/woocommerce';
import { TopSellingProductsContainer, SectionTitleWrapper } from './styles';

const renderSlideItem = (item: NormalizedProduct) => <SlideItem product={item} />;

const TopSellingProducts = ({ products }: { products: NormalizedProduct[] }) => {
  return (
    <TopSellingProductsContainer>
      <SectionTitleWrapper>
        <SectionTitle>Mais vendidos</SectionTitle>
      </SectionTitleWrapper>
      <Carousel data={products} renderItem={renderSlideItem} />
    </TopSellingProductsContainer>
  );
};

export default TopSellingProducts;
